import api from '../api'

export async function getAllows() {
  return api.get('traceability_production_daily_reports/allows');
}

export async function getTraceabilityProductionDailyReport(date) {
  return api.get(`traceability_production_daily_reports/${date}`);
}